import React, { useState, useEffect, useContext } from 'react'
import ReceiptItemHeader from './ReceiptItemHeader'
import ReceiptItemInner from './ReceiptItemInner'
import ReceiptItemFooter from './ReceiptItemFooter'
import { appContext } from '../../../App'
import { getCustomerAccountById } from '../../customers_accounts/CustomersAccountsFunctions'
import { getReceiptById } from '../ReceiptFunctions'
import { getInvoiceById } from '../../invoice/InvoiceFunctions'

export const receiptItemControllerContext = React.createContext()

function useReceiptItemController(props) {
  const app = useContext(appContext)
  const { receipt } = props
  const [receiptFor, setReceiptFor] = useState(null)
  const [receiptToView, setReceiptToView] = useState('OR')
  const [paperSize, setPaperSize] = useState(null)

  useEffect(() => {
    if (receipt.receipt_for.item_name === 'Invoice') {
      const invoice_id = receipt.receipt_for.item_id
      getInvoiceById(app, invoice_id)
      .then(invoice => {
        setReceiptFor(invoice)
        receipt.receipt_for.item = invoice
      })
    } else {
      // Maybe it's Customer Credit Account
      getCustomerAccountById(app, receipt.receipt_for.item_id.customer_account_id)
      .then(customer_account => {
        setReceiptFor(customer_account)
        receipt.receipt_for.item = customer_account
      })
    }

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (paperSize) window.print()
    return (() => setPaperSize(null))

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperSize])

  const obj = {
    client: app.client,
    paperSize: [paperSize, setPaperSize],
    receiptToView: [receiptToView, setReceiptToView],
    receipt,
    receiptFor,
    getReceiptById
  }

  return (obj)
}

function ReceiptItemController(props) {
  const receiptItemController = useReceiptItemController(props)

  return (
    <React.Fragment>
      <receiptItemControllerContext.Provider value={receiptItemController}>
        <ReceiptItemHeader />
        <ReceiptItemInner />
        <ReceiptItemFooter />
      </receiptItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ReceiptItemController)